<template>
  <div class="d-flex" id="wrapper">
    <NavigationSidebar />
    <!-- Page Content -->
    <div id="page-content-wrapper">
      <TopNavbar @toggled="toggleSidebarNav" :profile="getUserProfile" />

      <div class="card" style="min-height: 85vh">
        <div class="table-controls d-flex">
          <input
            type="text"
            class="form-control"
            placeholder="Search user"
            v-model="searchWord"
            @input="getUserManagment()"
          />
          <!-- Add btn -->
          <a
            data-toggle="modal"
            href="#addUserModalUserManagment"
            type="button"
            class="ml-auto btn btn-success text-nowrap desktop-only"
          >
            Add User
          </a>
        </div>
        <div class="container-fluid">
          <div class="row">
            <table class="table table-striped custom-table">
              <thead class="bg-dark">
                <tr>
                  <th nowrap scope="col">NAME</th>
                  <th nowrap scope="col">EMAIL</th>
                  <th nowrap scope="col">PHONE</th>
                  <th nowrap scope="col">ROLE</th>
                  <th nowrap scope="col">SOURCE</th>
                  <th nowrap scope="col">DATE FORMAT</th>
                  <th nowrap scope="col">TIME ZONE</th>
                  <th nowrap scope="col">ACTIONS</th>
                </tr>
              </thead>

              <tbody>
                <UserManagmentItem
                  @retrieve-user-management="retrieveUserManagment"
                  @delete-user-management="retrieveUserManagment"
                  v-for="user in users"
                  :key="user.id"
                  :id="`tr-${user.id}`"
                  :user="user"
                />
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <CustomMainModal @close="showModal = false" v-show="showModal">
      <template v-slot:header>
        <h5>Add User</h5>
      </template>
      <AddCandidateBtnModal />
    </CustomMainModal>

    <!-- Add User Modal -->
    <div
      class="modal fade add-user-modal"
      id="addUserModalUserManagment"
      tabindex="-1"
      aria-labelledby="addUserModalUserManagment"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addUserModalUserManagment">Add User</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              ref="closeUser"
              @click="clearFields"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="padding: 20px 40px">
            <div class="d-flex align-items-center">
              <div class="form-group flex-grow-1 mr-2">
                <div class="form-group m-label-left">
                  <input id="name" type="text" class="form-control" v-model="firstName" />
                  <label for="name">First Name</label>
                </div>

                <div class="form-group m-label-left">
                  <input id="lastname" type="text" class="form-control" v-model="lastName" />
                  <label for="lastname">Last Name</label>
                </div>

                <div class="form-group m-label-left">
                  <input id="email" type="text" class="form-control" v-model="editEmailAddress" />
                  <label for="email">Email</label>
                </div>
                <div class="row">
                  <div class="form-group m-label country-code-user col-md-4 no-hor">
                    <v-select
                      id="country-code"
                      @input="addCountryCode(countryCode)"
                      style="font-size: 14px; height: 42px"
                      v-model="countryCode"
                      :options="[...getAllCountries].map(item => `${item.phone_code} ${item.name}`)"
                      :clearable="false"
                    >
                      <template v-slot:option="option">
                        {{ option.label }}
                      </template>
                    </v-select>
                    <label for="country-code">Country Code</label>
                  </div>

                  <div class="form-group m-label col-md-8">
                    <input v-model="phone" id="phone" type="text" class="form-control" />
                    <label for="phone">Phone</label>
                  </div>
                </div>
                <div class="form-group m-label-left">
                  <select v-model="role" id="role" class="form-control">
                    <option value="12">Admin</option>
                    <option value="11">Recruiter</option>
                    <option value="10">Marketing</option>
                  </select>
                  <label for="role">Role</label>
                </div>
                <div class="form-group m-label-left">
                  <select v-model="selectedSource" class="form-control" id="source-pipeline-modal">
                    <option v-for="source in getSourceList" :key="source.id" :value="source">
                      {{ source.description }} ({{ source.source_name }})
                    </option>
                  </select>
                  <label for="role">Source</label>
                </div>
                <div class="form-group m-label-left">
                  <select v-model="dateFormat" id="addtime" class="form-control">
                    <option value="YY-MM-DD">YY-MM-DD</option>
                    <option value="YY/MM/DD">YY/MM/DD</option>
                    <option value="DD-MM-YY">DD-MM-YY</option>
                    <option value="DD/MM/YY">DD/MM/YY</option>
                    <option value="MM-DD-YY">MM-DD-YY</option>
                    <option value="MM/DD/YY">MM/DD/YY</option>
                  </select>
                  <label for="addtime">Date Format</label>
                </div>
                <div class="form-group m-label-left country-code-user">
                  <v-select
                    ref="tzSelect"
                    placeholder="Select Timezone"
                    v-model="timeZone"
                    :options="tzOptions"
                    :clearable="false"
                    :reduce="zone => zone"
                    :filterable="false"
                    label="utc_timezone"
                    @search="onTzSearch"
                    @open="onTzOpen"
                  >
                    <template #option="{ utc_timezone }">
                      {{ utc_timezone }}
                    </template>
                    <template #selected-option="{ utc_timezone }">
                      {{ utc_timezone }}
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer text-center justify-content-center">
            <button @click="createUser" type="button" class="btn btn-primary">Add User</button>

            <button
              @click="clearFields"
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import TopNavbar from '@/components/Navigations/TopNavbar';
import NavigationSidebar from '@/components/Navigations/Sidebar';
import CustomMainModal from '@/components/Modals/CustomMainModal';
import AddCandidateBtnModal from '../Candidates/AddCandidateBtnModal';
import UserManagmentItem from '@/components/Admin/UserManagment/UserManagmentItem';
import { toggleSidebarNav } from '../../../mixins/toggleSidebarNav';
import { mapActions, mapGetters } from 'vuex';
import { TIME_ZONES } from '../../../constants';
import titleMixin from '../../../mixins/titleMixin';

export default {
  components: {
    TopNavbar,
    NavigationSidebar,
    CustomMainModal,
    AddCandidateBtnModal,
    UserManagmentItem,
  },
  mixins: [toggleSidebarNav, titleMixin],
  title() {
    return 'User managment | Jobshark';
  },
  data: () => ({
    users: [],
    showModal: false,
    firstName: '',
    lastName: '',
    editEmailAddress: '',
    phone: '',
    selectedSource: '',
    timeZone: '',
    role: 11,
    dateFormat: 'YY-MM-DD',
    countryCode: '',
    searchWord: '',

    /* Delete variablse */
    deleteUserId: '',
    deleteUserName: '',
    delteUserLastName: '',
    tzOptions: [],
    tzPage: 1,
    tzLastPage: 1,
    tzSearch: '',
    tzLoading: false,
    tzSearchTimeout: null,
  }),
  methods: {
    ...mapActions(['retrieveUserProfile']),
    fetchTimezones(reset = false) {
      if (this.tzLoading) return;
      if (!reset && this.tzPage > this.tzLastPage) return;
      this.tzLoading = true;
      if (reset) {
        this.tzPage = 1;
        this.tzLastPage = 1;
      }
      axios(`${process.env.VUE_APP_API_URL}/common/timezone/all`, {
        method: 'post',
        data: { page: this.tzPage, count: 50, search_word: this.tzSearch },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          Accept: 'application/json',
        },
      })
        .then(res => {
          const raw = res.data.data !== undefined ? res.data.data : res.data;
          const items = Array.isArray(raw) ? raw : Object.values(raw);
          if (reset) {
            this.tzOptions = items;
          } else {
            const dropdown = this.$refs.tzSelect.$refs.dropdownMenu;
            const scrollTop = dropdown ? dropdown.scrollTop : 0;
            items.forEach(item => this.tzOptions.push(item));
            this.$nextTick(() => {
              if (dropdown) dropdown.scrollTop = scrollTop;
            });
          }
          this.tzLastPage = res.data.last_page;
          this.tzPage += 1;
        })
        .catch(() => {})
        .finally(() => {
          this.tzLoading = false;
        });
    },
    onTzSearch(search) {
      clearTimeout(this.tzSearchTimeout);
      this.tzSearchTimeout = setTimeout(() => {
        this.tzSearch = search;
        this.fetchTimezones(true);
      }, 300);
    },
    onTzOpen() {
      this.$nextTick(() => {
        const dropdown = this.$refs.tzSelect.$refs.dropdownMenu;
        if (!dropdown) return;
        dropdown.addEventListener('scroll', this.onTzScroll);
      });
    },
    onTzScroll(e) {
      const el = e.target;
      if (this.tzPage > this.tzLastPage) return;
      if (this.tzLoading) return;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 20) {
        this.fetchTimezones();
      }
    },
    addCountryCode(code) {
      this.countryCode = code.replace(/[0-9+]/g, '');
      this.phone = code.substring(0, code.indexOf(' ')) + ' ';
    },
    addCountryCodeEdit(code) {
      this.editCountryCode = code.replace(/[0-9+]/g, '');
      this.editPhone = code.substring(0, code.indexOf(' ')) + ' ';
    },
    getUserType(type) {
      if (type === 12) {
        return 'Admin';
      } else {
        return 'Recruiter';
      }
    },
    retrieveUserManagment() {
      axios(`${process.env.VUE_APP_API_URL}/admin/usermanagment/list`, {
        method: 'post',
        data: {
          /*   page: 1,
          count: 10, */
          search_word: this.searchWord,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(res => {
          this.users = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    createUser() {
      axios(`${process.env.VUE_APP_API_URL}/admin/usermanagment/create`, {
        method: 'post',
        data: {
          email: this.editEmailAddress,
          first_name: this.firstName,
          last_name: this.lastName,
          phone: this.phone,
          user_type: this.role,
          country_code: this.countryCode,
          format_date: this.dateFormat,
          timezone_id: this.timeZone.id,
        },
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(() => {
          this.retrieveUserManagment();
          this.$refs.closeUser.click();
          this.editEmailAddress = '';
          this.firstName = '';
          this.lastName = '';
          this.phone = '';
          this.role = 11;
          this.countryCode = '';
          this.selectedSource = '';
          this.dateFormat = this.getUserProfile.format_date;
          this.timeZone = {};
          this.$toasted.success('New user created', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        })
        .catch(err => {
          this.$toasted.error(err.response.data.errors.email, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 8000,
          });
        });
    },

    setForDelete(user) {
      this.deleteUserId = user.id;
      this.deleteUserName = user.first_name;
      this.delteUserLastName = user.last_name;
    },

    clearFields() {
      this.firstName = '';
      this.lastName = '';
      this.emailAddress = '';
      this.phone = '';
      this.role = 11;
      this.selectedSource = '';
      this.editEmailAddress = '';
      this.dateFormat = this.getUserProfile.format_date;
      this.timeZone = this.getUserProfile.timezone_data;
      this.countryCode = '';
    },
  },
  computed: {
    ...mapGetters(['getUserProfile', 'getAllCountries', 'getSourceList']),
    getTimeZones() {
      return TIME_ZONES;
    },
  },
  mounted() {
    this.retrieveUserManagment();
    this.fetchTimezones(true);
    this.retrieveUserProfile().then(() => {
      this.dateFormat = this.getUserProfile.format_date;
      this.timeZone = this.getUserProfile.timezone_data;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.table-controls {
  padding: 1rem;
  .form-control {
    font-family: $font-family-sans-lato;
    width: 30%;
  }
}
tr {
  th {
    &:nth-of-type(4) {
    }
    &:nth-of-type(5) {
    }
    &:last-of-type {
      padding-left: 20px;
    }
  }
  td {
    .icon-wrapper {
      float: right;
      margin-right: 18px;
    }

    /*  a {
      color: #a7a7a7;

      i {
        font-size: 16px;
      }
    } */
  }
}
.edit {
  fill: #a7a7a7;
}
svg {
  color: rgb(102, 102, 102);
}
</style>
